import type { SxProps, Theme } from '@mui/material/styles';

export const impactPageStyles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'hidden',
  },
  main: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
  },
  // Mobile: controls sit in normal flow above the map (not an absolute
  // overlay on top of it — the map has its own dedicated space below them),
  // and the Overview Panel/Projections Card are replaced by MobileBottomSheet.
  mobileMain: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  mobileControlsRow: (theme) => ({
    flexShrink: 0,
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
  }),
  mapRegion: (theme) => ({
    position: 'relative',
    flex: 1,
    minHeight: { xs: 420, md: 0 },
    backgroundColor: theme.palette.surface.mapWater,
    overflow: 'hidden',
    borderRadius: theme.radius('md'),
  }),
  controlsOverlay: (theme) => ({
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
    right: { xs: theme.spacing(2), md: 360 },
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    pointerEvents: 'none',
    '& > *': { pointerEvents: 'auto' },
  }),
  projectionsOverlay: (theme) => ({
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 2,
    maxWidth: 'calc(100% - 32px)',
  }),
};
